angular.module('impactx.search').service('SearchProcessService', SearchProcessService);

SearchProcessService.$inject = ['$rootScope', 'dataGen', 'searchFilter', '$location', '$route', '$securityManager', '$config'];

function SearchProcessService($rootScope, dataGen, searchFilter, $location, $route, $securityManager, $config) {
    var pathWatcher;
    var self = this;
    var allowedRoutes = ["vcatalog/", "search.product", "product/", "search.all", "tender/", "lot/", "supplier/", "manufacturer/"];
    var productRoute = "product/";
    var lastProductId = 0;

    function activateSearchProcess() {
        dataGen.postAsForm({}, {searchInput: searchFilter.searchInput}, "/search/activatesearchprocess").then(function () {
            lastProductId = 0;
            if (pathWatcher) {
                pathWatcher();
            }
            pathWatcher = $rootScope.$watch(function () {
                return $location.path();
            }, function (newRoute, oldRoute) {
                if (!$securityManager.isProcessAllowed("Search")) {
                    pathWatcher();
                }
                else {
                    if (!checkDeactivation(newRoute)) {
                        checkProductViewed(newRoute);
                    }
                }
            });
        });
    }

    function checkDeactivation(newRoute) {
        var allowed = false;
        for (var i = 0; i < allowedRoutes.length; i++) {
            if (newRoute.indexOf(allowedRoutes[i]) >= 0) {
                allowed = true;
                break;
            }
        }
        if (!allowed) {
            deactivateSearchProcess(newRoute);
        }
        return !allowed;
    }

    function checkProductViewed(newRoute) {
        if (newRoute.indexOf(productRoute) >= 0) {
            var productWatcher = $rootScope.$on('$locationChangeSuccess', function () {
                productWatcher();
                if ($securityManager.isProcessAllowed("Search")) {
                    var productId = $route.current.params.id;
                    if (productId > 0 && productId !== lastProductId) {
                        lastProductId = productId;
                        dataGen.postAsForm({}, {productId: productId}, "/search/viewproductprocess");
                    }
                }
            });

        }
    }

    function deactivateSearchProcess(newRoute) {
        if (pathWatcher) {
            pathWatcher();
        }
        if (newRoute.indexOf($config.loginRoute) < 0) {
            //was a logout
            if ($securityManager.isProcessAllowed("Search")) {
                return dataGen.postAsForm({}, {}, "/search/deactivatesearchprocess");
            }
        }
    }

    return {
        activateSearchProcess: activateSearchProcess
    };
}